// extracted by mini-css-extract-plugin
module.exports = {"top":"pages-module--top--2qUpv","text":"pages-module--text--1wnUq","header":"pages-module--header--37O3K","side":"pages-module--side--3qXvb"};